import {
  ArchiveIcon,
  AwardIcon,
  BabyIcon,
  BicepsFlexedIcon,
  BookImageIcon,
  BookMarkedIcon,
  BookOpenIcon,
  BuildingIcon,
  BusIcon,
  CakeIcon,
  CalculatorIcon,
  CalendarClockIcon,
  CalendarIcon,
  CarIcon,
  ClockIcon,
  CoffeeIcon,
  CreditCardIcon,
  CupSodaIcon,
  DatabaseIcon,
  FactoryIcon,
  FileTextIcon,
  FilmIcon,
  GiftIcon,
  GlobeIcon,
  GraduationCapIcon,
  HandCoinsIcon,
  HandshakeIcon,
  HeartIcon,
  HospitalIcon,
  LaptopIcon,
  MegaphoneIcon,
  MusicIcon,
  NewspaperIcon,
  PiggyBankIcon,
  StarIcon,
  TicketIcon,
  TreePalmIcon,
  TrophyIcon,
  TruckIcon,
  UserIcon,
  UtensilsIcon,
} from '@fukuri-admins/ui/common';
import { match } from 'ts-pattern';

type Props = {
  iconName: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xLg';
};

export const PortalIcon: React.FC<Props> = ({ iconName, size = 'md' }) =>
  match(iconName)
    .with('calendar', () => <CalendarIcon size={size} />)
    .with('vacation', () => <TreePalmIcon size={size} />)
    .with('event', () => <CalendarClockIcon size={size} />)
    .with('clock', () => <ClockIcon size={size} />)
    .with('member', () => <UserIcon size={size} />)
    .with('baby', () => <BabyIcon size={size} />)
    .with('heart', () => <HeartIcon size={size} />)
    .with('star', () => <StarIcon size={size} />)
    .with('car', () => <CarIcon size={size} />)
    .with('truck', () => <TruckIcon size={size} />)
    .with('bus', () => <BusIcon size={size} />)
    .with('office', () => <BuildingIcon size={size} />)
    .with('factory', () => <FactoryIcon size={size} />)
    .with('hospital', () => <HospitalIcon size={size} />)
    .with('calculator', () => <CalculatorIcon size={size} />)
    .with('newspaper', () => <NewspaperIcon size={size} />)
    .with('learning', () => <GraduationCapIcon size={size} />)
    .with('megaphone', () => <MegaphoneIcon size={size} />)
    .with('computer', () => <LaptopIcon size={size} />)
    .with('browser', () => <GlobeIcon size={size} />)
    .with('photo', () => <BookImageIcon size={size} />)
    .with('album', () => <BookMarkedIcon size={size} />)
    .with('document', () => <FileTextIcon size={size} />)
    .with('database', () => <DatabaseIcon size={size} />)
    .with('storage', () => <ArchiveIcon size={size} />)
    .with('card', () => <CreditCardIcon size={size} />)
    .with('coin', () => <HandCoinsIcon size={size} />)
    .with('ticket', () => <TicketIcon size={size} />)
    .with('savings', () => <PiggyBankIcon size={size} />)
    .with('meal', () => <UtensilsIcon size={size} />)
    .with('cake', () => <CakeIcon size={size} />)
    .with('coffee', () => <CoffeeIcon size={size} />)
    .with('drink', () => <CupSodaIcon size={size} />)
    .with('movie', () => <FilmIcon size={size} />)
    .with('music', () => <MusicIcon size={size} />)
    .with('fitness', () => <BicepsFlexedIcon size={size} />)
    .with('book', () => <BookOpenIcon size={size} />)
    .with('badge', () => <AwardIcon size={size} />)
    .with('trophy', () => <TrophyIcon size={size} />)
    .with('handshake', () => <HandshakeIcon size={size} />)
    .with('gift', () => <GiftIcon size={size} />)
    .otherwise(() => null);
